module.exports = __webpack_public_path__ + "static/img/smbg4.cacf0cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/smbg4.jpg
// module id = O0bH
// module chunks = 1